var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntroduce = function SvgIntroduce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m22.567 11.417-2.317 1.159-3-5.745 2.34-1.17a.75.75 0 0 1 1.001.323l2.306 4.415a.75.75 0 0 1-.33 1.018M3.75 12.476l-2.317-1.16a.75.75 0 0 1-.33-1.017L3.41 5.884a.75.75 0 0 1 1-.324L6.75 6.73z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m20.25 12.576-1.5 1.755-3.45 3.45a.75.75 0 0 1-.712.197l-5.433-1.359a.75.75 0 0 1-.28-.136L3.75 12.475"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m18.75 14.33-4.125-3-1.2.9a3 3 0 0 1-3.6 0l-.508-.38a.75.75 0 0 1-.08-1.13l3.668-3.67a.75.75 0 0 1 .53-.22h3.815"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m6.804 6.73 4.811-1.402a.75.75 0 0 1 .52.036l3.24 1.467M10.5 19.956l-2.826-.707a.75.75 0 0 1-.31-.161L5.25 17.25"
  })));
};
export default SvgIntroduce;